import React, { FC } from 'react';
import pdfStyles from '../../pdfDocument/pdfStyles';
import { BadgeText } from '../text/BadgeText';
import { BadgeFontSize } from '../../../../types/badge';
import { getFontFamily } from '../../utils';
import { FONT } from '../../../../types/enums';
import { Style } from '@react-pdf/types';

type Props = {
  name: string;
  fontSize: BadgeFontSize;
  styles?: Style | Style[];
};

export const BadgeName: FC<Props> = ({ name, fontSize, styles = {} }) => {
  const classes: Style[] = [pdfStyles.name, fontSize, pdfStyles.badgeNameMarginTop, getFontFamily(name, { fallbackFont: FONT.HELVETICA_BOLD }), (styles as Style)];

  return <BadgeText text={name} style={classes} />;
};
